var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar"},[_c('div',{staticClass:"img-wrapper"},[_c('div',{class:_vm.avatarUrl?'':'border-class',style:(_vm.getStyle)})])])
}
var staticRenderFns = []

export { render, staticRenderFns }